import React from 'react';
import { HelpCircle, MessageCircle, FileText, Mail } from 'lucide-react';

const BuyerHelpPage = () => {
  const helpTopics = [
    { icon: FileText, title: 'Getting Started', desc: 'Learn the basics of owning NFTs' },
    { icon: MessageCircle, title: 'FAQs', desc: 'Common questions and answers' },
    { icon: Mail, title: 'Contact Support', desc: 'Get help from our team' },
  ];

  return (
    <div style={{ padding: '40px' }}>
      <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#0B0B0B', marginBottom: '8px' }}>
        Help Center
      </h1>
      <p style={{ fontSize: '16px', color: '#999', marginBottom: '32px' }}>
        Find answers and get support
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
        {helpTopics.map((topic, i) => {
          const Icon = topic.icon;
          return (
            <div
              key={i}
              style={{
                background: '#FFFFFF',
                borderRadius: '12px',
                padding: '24px',
                border: '1px solid #E6E8EF',
                cursor: 'pointer',
                transition: 'border-color 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = '#4B9DFF'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = '#333'}
            >
              <Icon size={24} color="#4B9DFF" style={{ marginBottom: '12px' }} />
              <h3 style={{ color: '#0B0B0B', fontSize: '16px', marginBottom: '4px' }}>{topic.title}</h3>
              <p style={{ color: '#666', fontSize: '14px' }}>{topic.desc}</p>
            </div>
          );
        })}
      </div>

      <div style={{
        marginTop: '32px',
        background: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        border: '1px solid #E6E8EF'
      }}>
        <h3 style={{ color: '#0B0B0B', fontSize: '18px', marginBottom: '16px' }}>
          Need more help?
        </h3>
        <p style={{ color: '#999', fontSize: '14px', marginBottom: '16px' }}>
          Our support team is available Monday-Friday, 9am-6pm EST.
        </p>
        <button style={{
          background: '#4B9DFF',
          color: '#FFF',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer'
        }}>
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default BuyerHelpPage;
